import i18next from 'i18next';

i18next.init({
  interpolation: {
    escapeValue: false
  },
  lng: 'en',
  resources: {
    en: {
      translation: {
        registerLoginScreens: {
          WRONG_EMAIL_OR_PASS: 'Wrong email or password',
          EMAIL_REQUIRED: 'Email required',
          WRONG_EMAIL_CONFIRMATION:
            'There are different emails in email and confirm email fields',
          PASSWORD_REQUIRED: 'Password required',
          WRONG_PASSWORD_CONFIRMATION:
            'There are different values in password and confirm password fields',
          PASSWORD_MIN_LENGTH: 'Password should contains at least 8 characters',
          FIRST_NAME_REQUIRED: 'First name required',
          LAST_NAME_REQUIRED: 'Last name required',
          GENDER_REQUIRED: 'Gender required',
          BIRTH_DATE_REQUIRED: 'Date of Birth required',
          OVER_18_YEARS_OLD_REQUIRED:
            'You must be over 18 years of age to proceed',
          POSTCODE_REQUIRED: 'Postcode is required',
          SIGN_IN: 'Sign In',
          SIGN_IN_SUBTITLE: 'Welcome back!',
          SIGN_IN_DESCRIPTION:
            'Sign in using your registered email and password.',
          SIGN_IN_EMAIL_PLACEHOLDER: 'Type your email',
          SIGN_IN_PASSWORD_PLACEHOLDER: 'Minimum of 8 characters',
          EMAIL: 'E-mail',
          CONFIRM_EMAIL: 'Confirm E-mail',
          PASSWORD: 'Password',
          SIGN_UP: 'Join Deuce',
          SIGN_UP_SUBTITLE: 'Ready to play more tennis?',
          CONFIRM_PASSWORD: 'Confirm Password',
          SIGN_UP_DESCRIPTION:
            'Tell us your details and start your free trial today.',
          SIGN_UP_EMERGENCY_CONTACT_SUBTITLE: 'Emergency contact',
          SIGN_UP_EMERGENCY_CONTACT_DESCRIPTION:
            'Enter your emergency contact information here.',
          SIGN_UP_EMAIL_PLACEHOLDER: 'Type your email',
          SIGN_UP_PASSWORD_PLACEHOLDER: 'Minimum of 8 characters',
          SIGN_UP_FIRST_NAME_PLACEHOLDER: 'Enter your first name',
          SIGN_UP_LAST_NAME_PLACEHOLDER: 'Enter your last name',
          SIGN_UP_BIRTH_DATE_PLACEHOLDER: 'Enter your date of birth',
          SIGN_UP_POSTCODE_PLACEHOLDER: 'Enter postcode',
          FIRST_NAME: 'First Name',
          LAST_NAME: 'Last Name',
          BIRTH_DATE: 'Date of Birth',
          GENDER: 'Gender',
          POSTCODE: 'Postcode',
          TERMS_ACCEPTED_REQUIRED:
            'You need to accept the Terms and Conditions to setup your account',
          I_ACCEPT_THE: 'I accept the',
          TERMS_AND_CONDITIONS: 'Terms and Conditions',
          AND: 'and',
          PRIVACY_POLICY: 'Privacy Policy',
          ALREADY_MEMBER: 'Already a member?',
          NOT_A_MEMBER: 'Not yet a member?',
          JOIN_DEUCE: 'Join Deuce',
          EMERGENCY_CONTACT_NAME: 'Name',
          EMERGENCY_CONTACT_PHONE_NUMBER: 'Phone number',
          EMERGENCY_CONTACT_RELATIONSHIP: 'Relationship',
          EMERGENCY_CONTACT_EXISTING_CONDITIONS:
            'Any relevant pre-existing medical information',
          EMERGENCY_CONTACT_NAME_PLACEHOLDER: 'Enter name here',
          EMERGENCY_CONTACT_PHONE_NUMBER_PLACEHOLDER: 'Enter phone number here',
          EMERGENCY_CONTACT_RELATIONSHIP_PLACEHOLDER: 'Enter relationship here',
          EMERGENCY_CONTACT_EXISTING_CONDITIONS_PLACEHOLDER:
            'Enter any relevant medical information here',
          EMERGENCY_CONTACT_NAME_REQUIRED: 'Name required',
          EMERGENCY_CONTACT_PHONE_NUMBER_REQUIRED: 'Phone number required',
          EMERGENCY_CONTACT_RELATIONSHIP_REQUIRED: 'Relationship required',
          FORGOT_PASSWORD: 'Forgot password?'
        },
        header: {
          SIGN_IN: 'Sign In',
          SIGN_OUT: 'Sign Out',
          JOIN_DEUCE: 'Join',
          SESSIONS: 'Sessions',
          BOOKINGS: 'Bookings',
          ACCOUNT: 'Account',
          COURTS: 'Courts',
          MAGAZINE: 'Magazine',
          CLOSE: 'Close'
        },
        CONTINUE: 'Continue',
        NEXT_STEP: 'Next step',
        LOGOUT: 'Logout',
        JOIN: 'Join',
        MEMBER: 'Member',
        FETCHING_SESSION: 'Fetching Session...',
        MY_DEUCE: 'My Deuce',
        BACK: 'Back',
        SOMETHING_WENT_WRONG: 'Something went wrong',
        UPCOMING: 'Upcoming Sessions',
        FULLY_BOOKED: 'Fully Booked',
        YOU_MIGHT_LIKE: 'Other sessions you might like',
        FILTER_BY_AREA_PLACEHOLDER: 'Filter by venue area...',
        upcomingBookings: {
          NO_BOOKING_YET_SESSIONS_WILL: 'Sessions you book will appear here.',
          NO_BOOKING_YET_COURTS_WILL: 'Courts you book will appear here.',
          BOOK_A_SESSION_NOW: 'Book a session now.',
          BOOK_A_COURT_NOW: 'Book a court now.',
          UPCOMING_SESSIONS: 'Upcoming Sessions',
          UPCOMING_COURTS: 'Upcoming Courts',
          FETCHING_BOOKINGS: 'Fetching Bookings...',
          COURT: 'Court',
          SLOTS_AVAILABLE: 'Slots Available',
          PARTICIPANTS_GOING: 'Participants Going',
          INVITED_BY: 'Invited by'
        },
        bottomMenu: {
          BOOK_COURT: 'Book a Court',
          MATCHMAKER: 'Find a Player',
          GROUPS: 'Groups'
        },
        feedbackScreens: {
          THANKS_FOR_FEEDBACK: 'Thank you for your feedback.',
          SEND_FEEDBACK: 'Send feedback'
        },
        feedbackScreen: {
          APPRECIATE_FEEDBACK:
            'We would appreciate any feedback you can give us regarding our application. Please write it below.',
          SENDING_FEEDBACK: 'Sending feedback...',
          FEEDBACK: 'Feedback'
        },
        feedback: {
          BUBBLE_TEXT: 'Give feedback'
        },
        myDeuceScreen: {
          FETCHING_BOOKINGS: 'Fetching Bookings...',
          SESSIONS_BOOKINGS: 'Sessions Bookings',
          NO_SESSIONS_BOOKED: 'No sessions booked yet',
          CANCEL_SESSION: 'Cancel session',
          CANCEL_COURT: 'Cancel court'
        },
        sessionsScreen: {
          FETCHING_SESSIONS: 'Fetching Sessions...',
          SESSIONS: 'Sessions',
          BOOK_SLOT: 'BOOK',
          MORE_DATES_AND_LOCATIONS: 'More dates, times and locations',
          NO_SESSIONS_MATCH_YOUR_CRITERIA:
            'No sessions available that match your criteria.'
        },
        singleSessionScreen: {
          BOOK: 'BOOK',
          SLOT_LEFT: 'SLOT LEFT',
          SLOTS_LEFT: 'SLOTS LEFT',
          LEFT: 'LEFT',
          TODAY: 'TODAY',
          TOMORROW: 'TOMORROW',
          COACH_LABEL_TEXT: 'Coach',
          BOOK_SLOT: 'Book Slot',
          ATTENDIES: 'Attendees',
          NEXT: 'Next',
          CONFIRM_BOOKING: 'Confirm Booking',
          CANCEL: 'Cancel'
        },
        quickBookingFooter: {
          CONFIRM_BOOKING: 'Confirm Booking',
          CANCEL: 'CANCEL'
        },
        availableTimeScreen: {
          FULLY: 'Fully',
          BOOKED: 'Booked',
          LIMIT: 'Limit',
          EXCEEDED: 'Exceeded',
          AVAILABILITY_THIS_WEEK: 'Availability This Week',
          AVAILABLE_TIME: 'Available Time'
        },
        attendeesList: {
          PAGE_TITLE: 'Attendees list',
          VIEW_EMERGENCY_CONTACT_BUTTON: 'View emergency contact',
          GETTING_ERROR: 'Unable to get attendees list',
          FULL_NAME: 'Full name',
          BOOKING_DATE: 'Booking date',
          PRESENCE: 'Presence',
          PRESENT: 'Presence',
          ABSENT: 'Absent'
        },
        courtsScreen: {
          COURT: 'Court',
          COURTS: 'Courts',
          BOOK_COURT: 'Book Court',
          FETCHING_COURTS: 'Fetching courts...',
          COURT_BOOKED: 'Court Booked',
          WEEKLY_LIMIT_REACHED: 'Weekly limit reached',
          FULLY_BOOKED: 'Fully Booked',
          BOOK: 'Book',
          COURT_LEFT: 'Court Left',
          MORE_FILTERS: 'More filters...',
          SINGLES: 'Singles',
          DOUBLES: 'Doubles',
          NO_COURTS_MATCH_YOUR_CRITERIA:
            'No courts available that match your criteria.'
        },
        courtsFiltersScreen: {
          FILTER_COURTS: 'Filter Courts',
          FILTER: 'FILTER'
        },
        modals: {
          giveBack: {
            result: {
              CLOSE_BUTTON: 'Close',
              SUCCESS_1ST_LINE:
                'Your booking on this session has been succesfully cancelled.',
              SUCCESS_2ND_LINE:
                'Sorry you couldn\'t make it, hopefully we\'ll see you soon!'
            },
            confirm: {
              TITLE: 'Cancel your booking',
              ACTION_BUTTON: 'Confirm',
              CANCEL_BUTTON: 'Cancel',
              TEXT_1ST_LINE:
                'Are you sure you want cancel your session booking?',
              TEXT_2ND_LINE: '',
              ERROR:
                'Oops... something went wrong. Please try again later or contact to the Deuce Team.'
            }
          },
          courtCancel: {
            result: {
              CLOSE_BUTTON: 'Close',
              SUCCESS_1ST_LINE:
                'Your booking on this court has been succesfully cancelled.',
              SUCCESS_2ND_LINE:
                'Sorry you couldn\'t make it, hopefully we\'ll see you soon!'
            },
            confirm: {
              TITLE: 'Cancel your court booking',
              ACTION_BUTTON: 'Confirm',
              CANCEL_BUTTON: 'Cancel',
              TEXT_1ST_LINE: 'Are you sure you want cancel your court booking?',
              TEXT_2ND_LINE: '',
              ERROR:
                'Oops... something went wrong. Please try again later or contact to the Deuce Team.'
            }
          },
          emergency_contact: {
            TITLE: 'Emergency contact',
            CANCEL_BUTTON: 'Close',
            GETTING_ERROR:
              'There was an error during getting emergency contact. Maybe link expires.',
            EMERGENCY_CONTACT_NAME: 'Name',
            EMERGENCY_CONTACT_PHONE_NUMBER: 'Phone number',
            EMERGENCY_CONTACT_RELATIONSHIP: 'Relationship',
            EMERGENCY_CONTACT_EXISTING_CONDITIONS:
              'Any relevant pre-existing medical information'
          },
          booking: {
            CLOSE: 'Close',
            MAKE_BOOKING: 'Make booking',
            BOOKING: 'Booking',
            BOOKING_INFO:
              'Book a {{sessionName}} session at {{eventClubName}} ({{eventLocation}}) at {{eventDate}}',
            HOW_MANY_PLACES: 'How many places?',
            BOOKING_FAILED: 'Booking failed',
            inviteFriends: {
              CONFIRM_BOOKING: 'Confirm Booking',
              CLOSE: 'Close',
              PUT_EMAILS_SINGLES:
                'Enter email address of the friend you wish to invite.',
              PUT_EMAILS_DOUBLES:
                'Enter email addresses of the friends you wish to invite.',
              EMAIL_PLACEHOLDER: 'Enter their email here',
              BOOKING: 'Booking',
              BOOKING_FAILED: 'Email required',
              INVITE_FRIENDS_AND_MAKE_BOOKING: 'Invite & Confirm',
              PLEASE_DO_NOT_REPEAT_EMAILS: 'Please do not repeat emails',
              EMAIL_INCORRECT: 'Email incorrect'
            }
          },
          feedback: {
            SEND_FAILED: 'Check information is correct',
            CANCEL_BUTTON: 'Cancel',
            SEND_BUTTON: 'Improve Deuce',
            SENT_DONE_BUTTON: 'Back to Deuce',
            TITLE: 'Help us improve Deuce!',
            EMAIL_LABEL: 'E-mail',
            EMAIL_PLACEHOLDER: 'Your email',
            CONTENT_LABEL: 'Your comments',
            CONTENT_PLACEHOLDER: 'Suggestions here',
            SEND_ERROR: 'Check information is correct',
            SENT_1ST_LINE: 'Message sent!',
            SENT_2ND_LINE: 'Thank You for your feedback!'
          },
          bookingComplete: {
            DONE: 'Done',
            BOOKING_CONFIRMED: 'Booking Confirmed',
            BOOKING_FAILURE:
              'Sorry, we have been unable to complete this booking for you. ',
            INVITE_FRIENDS: 'Invite Friends',
            PLACE_AND_SESSION_NAME:
              'Booked {{bookingsNumber}} place for {{sessionName}} session',
            BOOKED_TYPE_OF_COURT: 'Booked an {{courtType}} court'
          },
          appRate: {
            HOW_LIKELY_DEUCE:
              'How likely are you to recommend Deuce to a friend?',
            ENJOYING_DEUCE: 'Enjoying Deuce?',
            CLOSE: 'Close',
            CANCEL: 'Cancel',
            SEND_RATING: 'Send rating',
            FINISH: 'Finish',
            ANY_OTHER_FEEDBACK: 'Any other feedback to help Deuce improve?',
            WRITE_HERE: 'Write here...'
          },
          welcome: {
            WELCOME: 'Welcome to Deuce, {{name}} and thanks for joining.',
            THANKS_FOR_PARTICIPATING:
              'Like you, people join because they want to play more tennis and they love the game. You\'re in good company!',
            WE_ARE_GOING_TO_SIMPLIFY:
              'We make it simple, fun and affordable to play more tennis.',
            SOON:
              'Deuce will continue to improve and we will be adding more features - so please visit often to keep tuned in',
            CONTINUE: 'Continue',
            LEARN_ABOUT_DEUCE_PREMIUM: 'Learn about Premium',
            FREE_SESSION_INFORMATION_1ST_LINE:
              'Deuce Premium will be launching in July',
            FREE_SESSION_INFORMATION_2ND_LINE:
              'Until then, all signed up members can play for free',
            JOIN_DEUCE_PREMIUM: 'JOIN DEUCE PREMIUM',
            NOT_JOIN_DEUCE_PREMIUM: 'DONE',
            BECOME_DEUCE_PREMIUM: 'Become a member of Deuce PREMIUM',
            DEUCE_PREMIUM_TOP_DESCRIPTION:
              'For £10 a month Deuce members can upgrade to Premium:' +
              'Book one court every day and Join one group Session every week',
            DEUCE_PREMIUM_BOTTOM_DESCRIPTION:
              'So for just £10 you could play tennis every day and take part in 4 fantastic Deuce Sessions a month, ' +
              'click Join below to be the first to know!',
            EMAIL_PLACEHOLDER: 'Type your email'
          },
          thankYouForHelp: {
            THANKS_FOR_HELP: 'Thank you for helping improve Deuce!',
            DONE: 'Done'
          },
          needToVerifyEmail: {
            PLEASE_VERIFY_EMAIL:
              'Please verify your e-mail address to continue to the Deuce app',
            OK: 'OK'
          },
          payments: {
            CONTINUE: 'Continue',
            PAYMENT_SUCCESS: 'Payment succesful',
            SUCCESS_SUBSCRIPTION:
              'You\'ve successfully subscribed to Deuce Premium!',
            GLAD_YOU_ARE_HERE: 'Thank you, we\'re glad to have you here.'
          },
          paymentsCancel: {
            ARE_YOU_SURE: 'Are you sure you want to cancel?',
            ALL_YOUR_BOOKINGS_AFTER:
              'All your session and court bookings after',
            WILL_BE_CANCELLED: 'will be cancelled.',
            ANY_QUESTIONS_CONCERNS:
              'We\'d love to have you stay, so please let us know what we could do to keep you in the club with the Give Feedback button on the right.',
            CANCEL_SUCCESS:
              'Your Deuce Premium account has successfully been cancelled',
            SORRY_TO_SEE_YOU_GO: 'We\'re sorry to see you go!',
            OK: 'OK',
            YES: 'CANCEL PREMIUM',
            NO: 'BACK',
            SOMETHING_WENT_WRONG: 'Sorry, something went wrong.'
          },
          updateCard: {
            UPDATE_SUCCESS: 'You\'ve succesfully updated your card',
            OK: 'OK'
          },
          cardUsed: {
            YOUR_CARD_USED: 'Your card was used earlier',
            SUBMIT_QUESTION:
              'Are you sure you want to submit subscription without free taster?',
            CHARGE_IMMEDIATELY: 'We will charge your card immediately.',
            BUY: 'Buy premium',
            CANCEL: 'Cancel'
          },
          startResetingPasswordSuccess: {
            OK: 'OK',
            START_RESETING_PASSWORD_SUCCESS:
              'You\'ve successfully started reseting password process.',
            PLEASE_CHECK_EMAIL: 'Please check your e-mail for reset link.'
          },
          confirmResettingPasswordSuccess: {
            OK: 'OK',
            CONFIRM_RESETING_PASSWORD_SUCCESS:
              'You\'ve successfully reset your password.',
            PLEASE_CHECK_EMAIL: 'You can now log in with the new credentials.'
          }
        },
        errorPageScreen: {
          PAGE_NOT_FOUND: 'Page not found.',
          PLEASE: 'Please',
          RETURN_HOME: 'return home',
          AND_TRY_AGAIN: 'and try again.',
          OPS_SORRY: 'Oops, something went wrong.'
        },
        deucePremium: {
          DEUCE_PREMIUM: 'Deuce Premium',
          PRICE: '£10',
          PERIOD: 'month',
          FIRST_MONTH_FOR_FREE: 'Enjoy your first month for free.',
          CANCEL_ANYTIME: 'Cancel at any time',
          FREE_COURT: '1 free court every day',
          FREE_SESSION: '1 free coaching session every week',
          START_FREE_TRIAL: 'START FREE TRIAL'
        },
        payments: {
          BUY_A_SUBSCRIPTION: 'Buy your Deuce Premium Membership',
          WILL_NOT_BE_CHARGED:
            'You will not be charged until after your taster ends on',
          WILL_SEND_AN_REMINDER_EMAIL:
            'and we\'ll send you an email reminder before then.',
          DURING_FREE_TRIAL:
            'During your first free month you can cancel at any time.',
          PRICE: '£10/month',
          CARD_NUMBER: 'Card number',
          EXPIRATION_DATE: 'Expiration date',
          CVC: 'CVC',
          BUY: 'BUY',
          PREPARING_PAYMENT: 'Preparing payment...',
          PROCESING_PAYMENT: 'Processing payment...',
          PROCESING_UPDATE: 'Processing update...',
          ERROR: 'Something went wrong. Please try again.',
          SUBSCRIPTION_CANCELLED: 'Your subscription was cancelled.',
          SUBSCRIPTION_EXPIRING: 'It will expire on ',
          CONTACT_DEUCE:
            'In case of any concerns, please contact the Deuce Team.',
          UPDATE_CARD: 'Update credit card details',
          UPDATE: 'Update'
        },
        account: {
          PREMIUM: 'Deuce Premium',
          SIGN_UP_DEUCE_PREMIUM: 'Sign up to Deuce Premium',
          CANCEL_SUBSCRIPTION: 'Cancel Premium Membership',
          UPDATE_CARD_INFORMATION: 'Update Card Information'
        },
        errorSubtypesMessages: {
          NON_AUTHORIZED_USER: 'You are not authorized.',
          NO_VALID_SUBSCRIPTION: 'You have no Deuce Premium subscription.',
          EVENT_ALREADY_BOOKED: 'You have already booked this event.',
          WEEKLY_LIMIT_REACHED:
            'You have reached your weekly limit for bookings.',
          DAILY_LIMIT_REACHED:
            'You have reached your daily limit for bookings.',
          CANCELED_EVENT: 'This event has been cancelled.',
          EVENT_IN_PAST: 'You can\'t book for the event in the future.',
          FULLY_BOOKED: 'This event is fully booked.'
        },
        bookingAvailabilityStatusesMessages: {
          NON_AUTHORIZED_USER: 'Non authorized user',
          NO_VALID_SUBSCRIPTION: 'No valid subscription',
          EVENT_ALREADY_BOOKED: 'Event already booked',
          WEEKLY_LIMIT_REACHED: 'Weekly limit reached',
          DAILY_LIMIT_REACHED: 'Daily limit reached',
          CANCELED_EVENT: 'Event cancelled',
          EVENT_IN_PAST: 'Event in the past',
          FULLY_BOOKED: 'Fully booked'
        },
        forgotPassword: {
          RESET_A_PASSWORD: 'Reset a password',
          RESET: 'Reset',
          EMAIL: 'E-mail',
          REPEATED_EMAIL: 'Confirm e-mail',
          EMAIL_PLACEHOLDER: 'Type your email',
          EMAIL_REQUIRED: 'Email is required',
          EMAILS_ARE_DIFFERENT: 'Emails are different',
          EMAIL_NOT_PROPER: 'Email is not proper',
          SOMETHING_WENT_WRONG: 'Something went wrong'
        },
        resetPassword: {
          CONFIRM_RESETING_PASSWORD: 'Confirm resetting your password',
          RESET: 'Reset',
          PASSWORD: 'Password',
          REPEATED_PASSWORD: 'Confirm password',
          PASSWORD_PLACEHOLDER: 'Type your password',
          PASSWORD_REQUIRED: 'Password is required',
          PASSWORDS_ARE_DIFFERENT: 'Paswords are different',
          PASSWORD_MUST_HAVE_MINIMUM_EIGHT_CHARS:
            'Password must have minimum 8 characters',
          SOMETHING_WENT_WRONG: 'Something went wrong'
        },
        gdprBanner: {
          WE_USE_COOKIES:
            'We use cookies to provide necessary functionality and to optimise our site. By clicking "Ok" you agree to our',
          COOKIE_POLICY: 'cookie policy',
          OK: 'OK'
        },
        months: {
          JANUARY: 'January',
          FEBRUARY: 'February',
          MARCH: 'March',
          APRIL: 'April',
          MAY: 'May',
          JUNE: 'June',
          JULY: 'July',
          AUGUST: 'August',
          SEPTEMBER: 'September',
          OCTOBER: 'October',
          NOVEMBER: 'November',
          DECEMBER: 'December'
        },
        weekDays: {
          monday: {
            NAME: 'Monday',
            SHORT_NAME: 'mon'
          },
          tuesday: {
            NAME: 'Tuesday',
            SHORT_NAME: 'tue'
          },
          wednesday: {
            NAME: 'Wednesday',
            SHORT_NAME: 'wed'
          },
          thursday: {
            NAME: 'Thursday',
            SHORT_NAME: 'thu'
          },
          friday: {
            NAME: 'Friday',
            SHORT_NAME: 'fri'
          },
          saturday: {
            NAME: 'Saturday',
            SHORT_NAME: 'sat'
          },
          sunday: {
            NAME: 'Sunday',
            SHORT_NAME: 'sun'
          }
        }
      }
    }
  }
});

export default i18next;



// WEBPACK FOOTER //
// ./src/utils/i18n.js